import { DataBean } from "../DataBean";

export class RecordType extends DataBean {
    
    


    public async getRecordTypeCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "java.util.List_getRecordTypeCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
  

}